import { StatelessPopupProps } from 'components/popup/stateless_popup/types';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { PickForStyled } from 'utils/types';

const fullscreenPadding = '1.5rem';
const popupPadding = '1rem';

type PopupContainerProps = Required<PickForStyled<StatelessPopupProps, 'popupZIndex'>>;
type PopupContentProps = Required<
    PickForStyled<
        StatelessPopupProps,
        'noPadding' | 'noPopupBackground' | 'noPopupBorder'
    >
>;
type FullScreenContainerProps = Required<
    PickForStyled<StatelessPopupProps, 'fullscreenZIndex'>
>;
type FullscreenContentProps = Required<PickForStyled<StatelessPopupProps, 'noPadding'>>;

export const FullScreenContainer = styled.div<FullScreenContainerProps>`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${tokens.background.paperElevation8};
    z-index: ${({ $fullscreenZIndex }) => $fullscreenZIndex};
`;

export const FullscreenHeader = styled.div`
    padding: ${fullscreenPadding};
`;

export const FullscreenContent = styled.div<FullscreenContentProps>`
    position: relative;
    padding: ${({ $noPadding }) =>
        $noPadding
            ? '0'
            : `0 ${fullscreenPadding} ${fullscreenPadding} ${fullscreenPadding}`};
`;

export const PopupContainer = styled.div<PopupContainerProps>`
    z-index: ${({ $popupZIndex }) => $popupZIndex};
`;

export const PopupOverlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const PopupContent = styled.div<PopupContentProps>`
    background: ${({ $noPopupBackground }) =>
        $noPopupBackground ? 'none' : tokens.background.paperElevation8};
    border: ${({ $noPopupBorder }) => ($noPopupBorder ? 'none' : tokens.popup.border)};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : popupPadding)};
`;
